import styles from './index.less';
import { useLocation } from '@@/exports';
import { useEffect } from 'react';
import { queryLeaveMessageDetail } from '@/pages/ServicesMore/service';
import {
  leaveMessageStatusEnum,
  leaveMessageStatusMap,
  leaveMessageTypeMap,
} from '@/pages/ServicesMore/config';
import { useSafeState } from 'ahooks';
import { LeaveMessageListType } from '@/pages/ServicesMore/interface';
import { Divider, Image, Tag } from 'react-vant';

const MessageDetail = () => {
  const location = useLocation();
  const { id } = location.state as { id: string };
  const [leaveMessageDetail, setLeaveMessageDetail] =
    useSafeState<LeaveMessageListType>();
  const [urlPathList, setUrlPathList] = useSafeState<string[]>([]);

  const loadMessageDetail = async () => {
    const res = await queryLeaveMessageDetail(id);
    console.log(res, 'message detail res');
    if (res?.code === 200) {
      setLeaveMessageDetail(res?.data);
      if (res?.data?.urlPath) {
        setUrlPathList(res?.data?.urlPath.split(','));
      }
    }
  };

  useEffect(() => {
    if (id) {
      loadMessageDetail();
    }
  }, [id]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>
          {leaveMessageDetail?.type
            ? leaveMessageTypeMap[leaveMessageDetail?.type]
            : ''}
          <Tag
            plain
            type={
              leaveMessageDetail?.status === leaveMessageStatusEnum.PROCESSED
                ? 'primary'
                : 'default'
            }
          >
            {leaveMessageDetail?.status
              ? leaveMessageStatusMap[leaveMessageDetail?.status]
              : '未回复'}
          </Tag>
        </div>
        <Divider dashed />
        <div className={styles.description}>
          <p>内容：{leaveMessageDetail?.content}</p>
        </div>
        <Divider dashed />

        {urlPathList.length > 0 && (
          <div className={styles.imgBox}>
            {urlPathList.map((item) => (
              <Image
                src={`${window.location.origin}${item}`}
                className={styles.img}
                width={100}
                height={100}
                key={item}
              />
            ))}
          </div>
        )}
        <Divider dashed />
        <div className={styles.time}>
          发布于：{leaveMessageDetail?.createTime}
        </div>
        {leaveMessageDetail?.status === leaveMessageStatusEnum.PROCESSED && (
          <>
            <Divider dashed />
            <div className={styles.reply}>
              <p>回复：{leaveMessageDetail?.replyContent}</p>
              <div className={styles.time}>
                回复于：{leaveMessageDetail?.replyTime}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MessageDetail;
